import { useTranslation } from 'react-i18next'
import { weddingTimeline } from '@/mocks/wedding'
import { buildWhatsAppLink } from '@/utils/whatsapp'

export default function WeddingTimelineSection() {
  const { t } = useTranslation()

  return (
    <section id="wedding-timeline" className="w-full bg-primary-950 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-primary-400" />
              <span className="section-label text-primary-300 text-[11px] md:text-xs font-medium">
                {t('wedding.timeline.label')}
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-background-50 leading-tight">
              {t('wedding.timeline.title')}
            </h2>
            <p className="mt-6 text-base text-background-200/80 leading-relaxed">{t('wedding.timeline.intro')}</p>

            <div className="mt-8 rounded-lg border border-primary-800 bg-primary-900/40 p-6">
              <span className="w-11 h-11 rounded-full flex items-center justify-center bg-primary-500 text-background-50 mb-4">
                <i className="ri-time-line text-xl" />
              </span>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-background-50 mb-2">
                {t('wedding.timeline.noteTitle')}
              </h3>
              <p className="text-sm text-background-200/80 leading-relaxed mb-5">
                {t('wedding.timeline.noteText')}
              </p>
              <a
                href={buildWhatsAppLink(t('common.enquireMessage', { topic: t('nav.wedding') }))}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-whatsapp-line text-base" />
                {t('common.enquire')}
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative">
              <span className="absolute left-[21px] top-3 bottom-3 w-px bg-primary-800" aria-hidden="true" />
              {weddingTimeline.map((step, index) => (
                <li
                  key={step.id}
                  className={`relative pl-16 md:pl-20 ${index !== weddingTimeline.length - 1 ? 'pb-8' : ''}`}
                >
                  <span className="absolute left-0 top-0 w-11 h-11 rounded-full flex items-center justify-center bg-primary-500 text-background-50">
                    <i className={`${step.icon} text-xl`} />
                  </span>
                  <div className="rounded-lg border border-primary-800 bg-primary-900/40 p-6">
                    <div className="flex flex-wrap items-center gap-3 mb-3">
                      <span className="text-xs font-medium px-3 py-1 rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                        {t(`wedding.timeline.steps.${step.id}.time`)}
                      </span>
                      <span className="text-[11px] tracking-[0.2em] uppercase text-primary-400">
                        {t('wedding.timeline.stepLabel')} {step.step}
                      </span>
                    </div>
                    <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-2">
                      {t(`wedding.timeline.steps.${step.id}.title`)}
                    </h3>
                    <p className="text-sm md:text-base text-background-200/80 leading-relaxed">
                      {t(`wedding.timeline.steps.${step.id}.desc`)}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  )
}